import { ValidatorFn, Validators } from '@angular/forms';
import { GrocyTransferProduct } from '../../../../core/entities/grocy/product-actions/product-action.entity';
import { GrocyQuantityUnitBasics } from '../../../../core/entities/grocy/quantity-units/quantity-unit-basics.entity';
import { GrocyStockEntry } from '../../../../core/entities/grocy/stock-entries/stock-entry.entity';
import { positive } from '../../../../forms/form-control-options.constants';
import { GrocyDashboardQuickActionTransferFormControls } from '../form-controls/dashboard-quick-action.form-controls';
import { GrocyDashboardQuickActionTransferFormOptions } from '../form-options/dashboard-quick-action-transfer.form-options';
import { GrocyDashboardQuickActionForm } from './dashboard-quick-action.form';

export class GrocyDashboardQuickActionTransferForm extends GrocyDashboardQuickActionForm<GrocyDashboardQuickActionTransferFormControls> {
  formGroup = this.createFormGroup(GrocyDashboardQuickActionTransferFormControls);
  override options = new GrocyDashboardQuickActionTransferFormOptions();

  public get amountHint(): string | undefined {
    return undefined;
  }

  public get productAction(): GrocyTransferProduct {
    return {
      amount: this.amount,
      productId: this.selectedProduct!.id,
      fromLocationId: this.controls.stockEntry.value!.location.id,
      stockEntryId: this.controls.stockEntry.value!.stockId,
      toLocationId: this.controls.toLocation.value!.id,
    };
  }

  public get quantityUnit(): GrocyQuantityUnitBasics | undefined {
    return this.selectedProduct?.quantityUnits.stock;
  }

  public setAmountToMax(): void {
    if (this.selectedProduct && this.controls.stockEntry.value) {
      this.controls.amount.setValue(this.controls.stockEntry.value.amount);
    }
  }

  public override canSelectStockEntry(stockEntry: GrocyStockEntry): boolean {
    return stockEntry.amount > 0;
  }

  protected setChangeListeners(): void {
    this.controls.stockEntry.valueChanges.subscribe(stockEntry => {
      if (stockEntry) {
        this.controls.amount.setValidators([
          Validators.required,
          Validators.min(0.000001),
          Validators.max(stockEntry.amount),
        ]);
        this.controls.amount.setValue(stockEntry.amount);
        this.controls.amount.updateValueAndValidity();

        this.controls.toLocation.setValue(this.options.grocyLocations.find(l => l.id === stockEntry.location.id)!);
      }
    });
  }

  protected setInitialValues(): void {
    this.controls.amount.setValidators([
      ...(positive.validators as ValidatorFn[]),
      Validators.max(this.selectedProduct?.stockAmount || 0),
    ]);

    if (this.selectedProduct) {
      if (this.selectedProduct?.stockEntries.length === 0) {
        this.disableForm();
      } else {
        const stockEntry = this.selectedProduct?.stockEntries[0];
        this.controls.stockEntry.setValue(stockEntry);
        this.controls.fromLocation.setValue(this.options.grocyLocations.find(l => l.id === stockEntry.location.id)!);
        this.controls.toLocation.setValue(this.options.grocyLocations.find(l => l.id === stockEntry.location.id)!);
        this.enableForm();
      }
    }
  }

  private disableForm(): void {
    this.controls.amount.disable();
    this.controls.stockEntry.disable();
    this.controls.toLocation.disable();
    this.formGroup.markAllAsTouched();
  }

  private enableForm(): void {
    this.controls.amount.enable();
    this.controls.stockEntry.enable();
    this.controls.toLocation.enable();
  }
}
